import { ReactNode } from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

/**
 * 主题 Provider 组件
 * 
 * 基于 next-themes 的主题 Provider，提供完整的主题管理功能。
 * 
 * 功能：
 * - 初始化主题系统
 * - 监听系统主题变化
 * - 自动同步主题到 HTML 元素（通过 `.dark` 类）
 * - 防止主题闪烁（FOUC）
 * 
 * 使用方式：
 * ```tsx
 * <ThemeProvider>
 *   <App />
 * </ThemeProvider>
 * ```
 * 
 * 参考：https://ui.shadcn.com/docs/theming
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange={false}
    >
      {children}
    </NextThemesProvider>
  );
}

